export const SESSION_HANDOFF_DECISIONS = Object.freeze({
  TAKEOVER: 'takeover',
  KEEP_EXISTING: 'keep-existing',
});

export function isSessionConflictError(error) {
  const raw = [error?.code, error?.message, error?.details, error?.hint, error]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();
  return raw.includes('session_conflict')
    || raw.includes('session_conflict_changed');
}

export function classifySessionState(data) {
  const status = String(data?.status || data?.reason || '').toLowerCase();
  if (status === 'available' || status === 'active') return status;
  if (status === 'conflict' || status === 'session_conflict') return 'conflict';
  return 'unavailable';
}

export function sessionGeneration(data) {
  const generation = Number(data?.session_generation);
  return Number.isSafeInteger(generation) && generation >= 0 ? generation : null;
}
